import React, {HTMLInputTypeAttribute, useState} from "react";
import styled from "styled-components";
import {Primitive} from "../../../../../Types";

interface PropsI {
    value: string,
    onChange: (arg: Primitive, invalid?: boolean) => void,
    name: string,
    type: HTMLInputTypeAttribute
}

export default function RawEditStringInput({value, onChange, name, type}: PropsI) {

    let [newValue, setNewValue] = useState<string>(value === null ? '' : value)
    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewValue(e.currentTarget.value);
    };

    return <TextInput name={"edit-" + name} id={"edit-" + name}
                  type={type}
                  value={newValue}
                  onBlur={() => onChange(newValue)}
                  onChange={onChangeHandler}></TextInput>

}

const TextInput=  styled.input`
    text-indent: 2px;
    font-size: 1rem;
`
